export default "__VITE_ASSET__Cp1OgnV2__"